<tt-page>
    <tt-material-item [params]="params" (submit)="onSubmit()"></tt-material-item>
</tt-page>
